<script>
	import { onDestroy } from "svelte";
	import windows from "../../stores/windows.js";
	import cairns from "../../stores/cairn.js";

	export let window;

	let isCopied = false;
	let copiedResetTimerId;

	function didClickLocateButton() {
		const { cairn } = window.props;
		cairns.remember(cairn);

		const id = windows.open("map", {
			follow: "__cairn__",
			center: cairn,
			cairn
		});

		if (id === undefined) {
			return;
		}

		windows.focus(id);
	}

	async function didClickCopyLinkButton() {
		const { cairn } = window.props;
		const reference = cairn.id || cairn.slug;

		if (reference === undefined || reference === null) {
			return;
		}

		const url = new URL(location.href);
		url.hash = `cairn:${reference}`;

		const didCopy = await didCopyLink(url.toString());

		if (didCopy === false) {
			return;
		}

		didStartCopiedState();
	}

	function didCopyWithExecCommand(text) {
		const textarea = document.createElement("textarea");
		textarea.value = text;
		textarea.setAttribute("readonly", "");
		textarea.style.position = "fixed";
		textarea.style.opacity = "0";
		document.body.appendChild(textarea);
		textarea.focus();
		textarea.select();

		let didCopy = false;

		try {
			didCopy = document.execCommand("copy");
		} catch (error) {
			didCopy = false;
		}

		document.body.removeChild(textarea);

		return didCopy;
	}

	function didStartCopiedState() {
		isCopied = true;

		if (copiedResetTimerId !== undefined) {
			clearTimeout(copiedResetTimerId);
		}

		copiedResetTimerId = setTimeout(didResetCopiedState, 5_000);
	}

	function didResetCopiedState() {
		isCopied = false;
		copiedResetTimerId = undefined;
	}

	async function didCopyLink(text) {
		const isSecureContext = globalThis.isSecureContext === true;

		if (navigator.clipboard !== undefined && isSecureContext === true) {
			try {
				await navigator.clipboard.writeText(text);
				return true;
			} catch (error) {}
		}

		if (isSecureContext === false) {
			const didCopy = didCopyWithExecCommand(text);
			globalThis.prompt("Copy this link:", text);
			return didCopy;
		}

		if (didCopyWithExecCommand(text) === true) {
			return true;
		}

		globalThis.prompt("Copy this link:", text);
		return false;
	}

	function didDestroy() {
		if (copiedResetTimerId === undefined) {
			return;
		}

		clearTimeout(copiedResetTimerId);
	}

	onDestroy(didDestroy);
</script>

<button on:click={didClickLocateButton}>
	<span>
		<svg width="15" height="15" viewBox="0 0 15 15" fill="black">
			<path
				d="M14.2441 0.898895L0.24408 7.70842L6 9L8 15L14.2441 0.898895Z"
			/>
		</svg>
	</span>
</button>

<div class="spacer" />

<button
	disabled={(window.props.cairn.id === undefined && window.props.cairn.slug === undefined) || isCopied === true}
	on:click={didClickCopyLinkButton}>{isCopied === true ? "Copied" : "Copy Link"}</button
>

<style>
	button {
		appearance: none;
		cursor: pointer;
		margin: var(--spacing);
		border: none;
		background: none;
		padding: 0;
		touch-action: manipulation;
		color: #000000;
		text-decoration: underline;
		white-space: nowrap;
	}

	.spacer {
		flex-grow: 1;
	}

	button:disabled {
		pointer-events: none;
		color: #999999;
		text-decoration: none;
		text-shadow: 0 1px rgba(255, 255, 255, 0.75);
	}
</style>
